import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

const options = {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  // pauseOnFocusLoss: true,
  // pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  hideProgressBar: false,
}

export default (app) => {
  app.use(Toast, options)
}